export default "__VITE_ASSET__D88VOJ84__"